<template>
  <div class="q-py-xl">
    <div class="text-center text-primary text-weight-bold" style="font-size: 2.75rem">
      AI-powered financial analysis on any property
    </div>
    <div class="text-center text-grey-7 q-mb-xl text-subtitle1">
      Instantly analyze multifamily investments or benchmark expenses in any market with only a
      property name or address.
    </div>
  </div>
  <div class="subscribe-financial-analysis">
    <checkout-card
      plan-name="Financial Analysis Add-On"
      :price="price"
      :promo-formatted-price="formattedPrice"
      :trial-days="0"
      add-on
      @create-subscription="createSubscription"
    >
      <div>
        <div>
          <div class="text-weight-medium">Activate Financial Analysis Add-On</div>
          <div class="text-grey-9">{{ formattedPrice }}</div>
        </div>
      </div>
    </checkout-card>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import CheckoutCard from '@/components/CheckoutCard.vue'

export default {
  name: 'SubscribeFinancialAnalysisView',
  components: {
    CheckoutCard
  },
  computed: {
    price() {
      return useStripeStore().billedPerSeat ? 200 : 0.2
    },
    formattedPrice() {
      return useStripeStore().billedPerSeat ? '$200/user/month' : '$0.20/unit/month'
    }
  },
  methods: {
    async createSubscription(payload: {
      paymentId: string
      couponId?: string
      cb: () => void
      failCb: () => void
    }) {
      const sub = await useStripeStore().createFinancialAnalysisSubscription()
      if (sub) {
        payload.cb()
      } else {
        payload.failCb()
      }
    }
  }
}
</script>
<style scoped>
.subscribe-financial-analysis {
  max-width: 1280px;
  margin: auto;
}
</style>
